import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ButtonBase from '@/design-system/atoms/buttons/ButtonBase.vue'
import { ref } from 'vue'

type Emits = {
  (e: 'onClicked')
}

type Props = {
  buttonText?: string
  disabled?: boolean
  iconLeft?: string
  iconRight?: string
  size?: string
  active?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonToggle',
  props: {
    buttonText: { default: '' },
    disabled: { type: Boolean, default: false },
    iconLeft: { default: '' },
    iconRight: { default: '' },
    size: { default: 'medium' },
    active: { type: Boolean, default: false }
  },
  emits: ["onClicked"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emits = __emit

const hover = ref(false)

function onClicked() {
  if (!props.disabled) {
    emits('onClicked')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ButtonBase, {
    buttonText: _ctx.buttonText,
    class: _normalizeClass({ 'button-toggle': !_ctx.disabled, 'button-active': _ctx.active }),
    disabled: _ctx.disabled,
    iconLeft: _ctx.iconLeft,
    iconRight: _ctx.iconRight,
    size: _ctx.size,
    whiteContent: hover.value || _ctx.active,
    onOnClicked: onClicked,
    onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (hover.value = true)),
    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (hover.value = false))
  }, null, 8, ["buttonText", "class", "disabled", "iconLeft", "iconRight", "size", "whiteContent"]))
}
}

})